import {
  BackButton,
  Container,
  Page,
  PageTitle,
} from '@foxtrotplatform/developer-platform-common-ui-component-lib';
import { useOrganization } from '@foxtrotplatform/platform-micro-site-core';
import { FunctionComponent, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { MessageCard } from '../../../common/components/MessageCard';
import { DeveloperOrganizationContextProps } from '../../../common/providers/types';
import { SelectCreateTeamCard } from '../../Teams/SelectCreateTeamCard';
import organizationIcon from '../assets/organization.svg';
import { OrganizationCheck } from '../OrganizationCheck';

export const OrganizationExists: FunctionComponent = (): JSX.Element | null => {
  const navigate = useNavigate();
  const { isOrganizationsReady, requiresOrgOnboarding } =
    useOrganization() as DeveloperOrganizationContextProps;

  useEffect(() => {
    if (isOrganizationsReady && !requiresOrgOnboarding) {
      navigate('/organization');
    }
  }, [isOrganizationsReady, requiresOrgOnboarding]);

  return (
    <Page>
      <Container size="medium">
        <OrganizationCheck />
        <div className="flex flex-row items-center gap-x-3">
          <BackButton />
          <PageTitle>Join a team</PageTitle>
        </div>
        <MessageCard
          description="To develop apps, you must join a team. You can join the following teams or create a new one."
          iconSource={organizationIcon}
        />
        <SelectCreateTeamCard />
      </Container>
    </Page>
  );
};
